import { render, staticRenderFns } from "./uiColorPicker.vue?vue&type=template&id=374953ab&scoped=true"
import script from "./uiColorPicker.vue?vue&type=script&lang=js"
export * from "./uiColorPicker.vue?vue&type=script&lang=js"
import style0 from "./uiColorPicker.vue?vue&type=style&index=0&id=374953ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374953ab",
  null
  
)

export default component.exports